/**
 * @generated SignedSource<<d024e21b11d629b4ea0fef6baf7ad319>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAskCopilotSendMessageViaConversationMutation$variables = {
  content: string;
  contentForDisplay?: string | null;
  conversationId: string;
  messageId?: string | null;
  snippetIds?: ReadonlyArray<string> | null;
};
export type useAskCopilotSendMessageViaConversationMutation$data = {
  readonly askCopilotSendMessage: {
    readonly conversation: {
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInnerFragment">;
    };
  } | null;
};
export type useAskCopilotSendMessageViaConversationMutation = {
  response: useAskCopilotSendMessageViaConversationMutation$data;
  variables: useAskCopilotSendMessageViaConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentForDisplay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "conversationId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "messageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "snippetIds"
},
v5 = [
  {
    "kind": "Variable",
    "name": "content",
    "variableName": "content"
  },
  {
    "kind": "Variable",
    "name": "contentForDisplay",
    "variableName": "contentForDisplay"
  },
  {
    "kind": "Variable",
    "name": "conversationId",
    "variableName": "conversationId"
  },
  {
    "kind": "Variable",
    "name": "messageId",
    "variableName": "messageId"
  },
  {
    "kind": "Variable",
    "name": "snippetIds",
    "variableName": "snippetIds"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentForDisplay",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAskCopilotSendMessageViaConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "AskCopilotSendMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AskFellowPanelInnerFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAskCopilotSendMessageViaConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "AskCopilotSendMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotMessage",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentJson",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pending",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isResponse",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "error",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userRating",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotConversationContext",
                "kind": "LinkedField",
                "name": "context",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filters",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "object",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "haveOngoingBotlessRecording",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reachedMessageLimit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "20c3b368b5e5e96aef806d682ce43bb9",
    "id": null,
    "metadata": {},
    "name": "useAskCopilotSendMessageViaConversationMutation",
    "operationKind": "mutation",
    "text": "mutation useAskCopilotSendMessageViaConversationMutation(\n  $conversationId: ID!\n  $content: String!\n  $contentForDisplay: String\n  $messageId: String\n  $snippetIds: [ID!]\n) {\n  askCopilotSendMessage(content: $content, contentForDisplay: $contentForDisplay, conversationId: $conversationId, messageId: $messageId, snippetIds: $snippetIds) {\n    conversation {\n      ...AskFellowPanelInnerFragment\n      id\n    }\n  }\n}\n\nfragment AskFellowPanelInnerFragment on AskCopilotConversation {\n  id\n  title\n  messages {\n    id\n    role\n    content\n    contentJson\n    pending\n    createdAt\n    isResponse\n    contentForDisplay\n    error\n    ...AskFellowPanelInner_ChatMessage_message\n  }\n  ...SuggestedQuestionsWrapper_conversation\n  context {\n    haveOngoingBotlessRecording\n  }\n  reachedMessageLimit\n}\n\nfragment AskFellowPanelInner_ChatMessage_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentJson\n  contentForDisplay\n  pending\n  isResponse\n  error\n  ...AskFellowPanelInner_RatingButtons_message\n}\n\nfragment AskFellowPanelInner_RatingButtons_message on AskCopilotMessage {\n  id\n  userRating\n}\n\nfragment SuggestedQuestionsWrapper_conversation on AskCopilotConversation {\n  id\n  suggestedQuestions {\n    id\n    content\n    contentForDisplay\n  }\n  context {\n    name\n    filters\n    object {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91cb299691608b5d9c18957fd2f1c675";

export default node;
